class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-link');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

// Terms & Conditions — event delegation, ingen polling, ingen rebinding
(function () {
  const CHECKBOX_ID = 'CartDrawer-AcceptTerms';
  const CHECKOUT_ID = 'CartDrawer-Checkout';
  let errorTimeout = null;

  function syncButton(checkbox) {
    const btn = document.getElementById(CHECKOUT_ID);
    if (!btn) return;
    if (checkbox.checked) {
      btn.classList.remove('cart__checkout-button--disabled');
      btn.setAttribute('aria-disabled', 'false');
    } else {
      btn.classList.add('cart__checkout-button--disabled');
      btn.setAttribute('aria-disabled', 'true');
    }
  }

  function showTermsError(checkbox) {
    const wrapper = checkbox.closest('.cart-terms-wrapper');
    if (!wrapper) return;

    wrapper.classList.remove('cart-terms-shake');
    void wrapper.offsetWidth;
    wrapper.classList.add('cart-terms-shake');
    wrapper.addEventListener('animationend', () => {
      wrapper.classList.remove('cart-terms-shake');
    }, { once: true });

    const locale = window.Shopify?.locale || 'da';
    const messages = {
      da: 'Du skal acceptere handelsbetingelserne for at fortsætte.',
      en: 'Please accept the terms and conditions to continue.',
      de: 'Bitte akzeptiere die Allgemeinen Geschäftsbedingungen, um fortzufahren.',
      nb: 'Du må godta vilkårene og betingelsene for å fortsette.',
      fr: 'Veuillez accepter les conditions générales pour continuer.',
    };
    const msg = messages[locale] || messages.da;

    let errorEl = wrapper.querySelector('.cart-terms-error-msg');
    if (!errorEl) {
      errorEl = document.createElement('p');
      errorEl.className = 'cart-terms-error-msg';
      errorEl.style.cssText = 'color:#c0392b;font-size:1.2rem;margin-top:0.5rem;margin-bottom:0;';
      wrapper.appendChild(errorEl);
    }
    errorEl.textContent = msg;

    clearTimeout(errorTimeout);
    errorTimeout = setTimeout(() => { errorEl.textContent = ''; }, 4000);
  }

  // Checkbox ændrer sig — delegeret, virker også efter drawer re-render
  document.addEventListener('change', function (e) {
    if (e.target && e.target.id === CHECKBOX_ID) {
      syncButton(e.target);
    }
  });

  // Checkout-klik — kun matcher vores knap-ID, rører intet andet på siden
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('#' + CHECKOUT_ID);
    if (!btn) return;

    const checkbox = document.getElementById(CHECKBOX_ID);
    if (!checkbox || !checkbox.checked) {
      e.preventDefault();
      e.stopPropagation();
      if (checkbox) showTermsError(checkbox);
      return;
    }

    const form = document.getElementById('CartDrawer-Form');
    if (form) {
      const submitBtn = document.createElement('button');
      submitBtn.type = 'submit';
      submitBtn.name = 'checkout';
      submitBtn.style.display = 'none';
      form.appendChild(submitBtn);
      submitBtn.click();
      form.removeChild(submitBtn);
    } else {
      window.location.href = '/checkout';
    }
  }, true);

  // Sæt korrekt state ved load
  document.addEventListener('DOMContentLoaded', function () {
    const checkbox = document.getElementById(CHECKBOX_ID);
    if (checkbox) syncButton(checkbox);
  });
})();